var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ItemOrderControl" }, [
    _c("div", { staticClass: "ItemOrderControl_Item" }, [
      _c(
        "a",
        {
          on: {
            click: function($event) {
              _vm.onChangeSelectedItemLabel(-1)
            }
          }
        },
        [_vm._v("\n      <\n    ")]
      )
    ]),
    _vm._v(" "),
    _c("div", [
      _c("input", {
        staticClass: "ItemOrderControl_Input",
        attrs: { type: "text" },
        domProps: { value: _vm.selectedItemLabel }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ItemOrderControl_Item" }, [
      _c(
        "a",
        {
          on: {
            click: function($event) {
              _vm.onChangeSelectedItemLabel(1)
            }
          }
        },
        [_vm._v("\n      >\n    ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }